import { render, staticRenderFns } from "./view-map-create-update.vue?vue&type=template&id=f2356f04&"
import script from "./view-map-create-update.vue?vue&type=script&lang=js&"
export * from "./view-map-create-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports